import { Pipe, PipeTransform, inject } from '@angular/core';
import { GeneralUserService } from '@coin/shared/auth/data-access';
import { Observable, of } from 'rxjs';
import { EmployeeLight } from '@coin/shared/core/util-models';

@Pipe({
  name: 'employeeLightByGid$',
  standalone: true
})
export class EmployeeLightByGidPipe implements PipeTransform {
  private readonly employeeService = inject(GeneralUserService);

  transform(gid: string): Observable<EmployeeLight> {
    if (gid) {
      return this.employeeService.getEmployeeLightDetailsByGid(gid);
    }
    return of(null);
  }
}
